// extracted by mini-css-extract-plugin
module.exports = {"GrayBtn":"Button_GrayBtn__1euoJ","GrayBtnTxt":"Button_GrayBtnTxt__8yLo0","WhiteBtn":"Button_WhiteBtn__3RW7O","WhiteBtnTxt":"Button_WhiteBtnTxt__1jW1q"};